import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { UserGroup, UserItemWrapper } from './subcomponents';
import { FAR_USER_CIRCLE } from '../../../../../../const/icon-props';
import { translate } from '../../../../strings/i18n';
import colors from '../../../../../../const/colors';
import Icon from '../../../../../icon';
const UserItem = ({ name, isNewUserConfirmation }) => {
    return (_jsxs(UserItemWrapper, { horizontal: "medium", isNewUserConfirmation: isNewUserConfirmation, children: [_jsxs(UserGroup, { children: [_jsx(Icon, { icon: FAR_USER_CIRCLE, title: "User Icon", size: "2x", color: colors.mediumDarkBlue }), _jsx(Inset, { left: "base", children: name })] }), !isNewUserConfirmation && _jsx("b", { children: translate('authorizedUser') })] }));
};
export default UserItem;
